import React from "react";
import PropTypes from "prop-types";
import i18n from "i18n-react";
import { FaUserCheck, FaReceipt } from "react-icons/fa";
import DashboardMetricCard from "../../../components/dashboard/DashboardMetricCard";
import { formatCurrency, formatNumber } from "./ordersDashboardFormatters";

const AveragesPanel = ({ dashboard }) => {
    const activeSellers = dashboard?.sellers?.length || 0;
    const activeSellersLabel = String(i18n.translate("orders_dashboard_active_sellers"));

    return (
        <>
            <div className="orders-divider" />
            <div className="orders-section-label">{i18n.translate("orders_dashboard_key_averages")}</div>
            <div className="orders-average-grid">
                <DashboardMetricCard
                    icon={<FaUserCheck />}
                    label={i18n.translate("orders_dashboard_average_sale_per_seller")}
                    value={formatCurrency(dashboard?.averageSalePerSeller)}
                    context={`${formatNumber(activeSellers)} ${activeSellersLabel}`}
                />
                <DashboardMetricCard
                    icon={<FaReceipt />}
                    label={i18n.translate("orders_dashboard_average_ticket")}
                    value={formatCurrency(dashboard?.averageTicket)}
                    context={i18n.translate("orders_dashboard_per_processed_order")}
                />
            </div>
        </>
    );
};

AveragesPanel.propTypes = {
    dashboard: PropTypes.shape({
        sellers: PropTypes.arrayOf(PropTypes.object),
        averageSalePerSeller: PropTypes.number,
        averageTicket: PropTypes.number
    }).isRequired
};

export default AveragesPanel;
